var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 88,
    height: 88,
    rx: 20,
    fill: "#FFE8E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3338 52.6601C39.5538 52.6601 35.6738 48.7801 35.6738 44.0001C35.6738 39.2201 39.5538 35.3401 44.3338 35.3401C49.1138 35.3401 52.9938 39.2201 52.9938 44.0001C52.9938 48.7801 49.1138 52.6601 44.3338 52.6601ZM44.3338 38.3401C41.2138 38.3401 38.6738 40.8801 38.6738 44.0001C38.6738 47.1201 41.2138 49.6601 44.3338 49.6601C47.4538 49.6601 49.9938 47.1201 49.9938 44.0001C49.9938 40.8801 47.4538 38.3401 44.3338 38.3401Z",
    fill: "#FF3F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3341 62.04C36.8141 62.04 29.7141 57.64 24.8341 50C22.7141 46.7 22.7141 41.32 24.8341 38C29.7341 30.36 36.8341 25.96 44.3341 25.96C51.8341 25.96 58.9341 30.36 63.8141 38C65.9341 41.3 65.9341 46.68 63.8141 50C58.9341 57.64 51.8341 62.04 44.3341 62.04ZM44.3341 28.96C37.8741 28.96 31.6941 32.84 27.3741 39.62C25.8741 41.96 25.8741 46.04 27.3741 48.38C31.6941 55.16 37.8741 59.04 44.3341 59.04C50.7941 59.04 56.9741 55.16 61.2941 48.38C62.7941 46.04 62.7941 41.96 61.2941 39.62C56.9741 32.84 50.7941 28.96 44.3341 28.96Z",
    fill: "#FF3F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d2101bd7f21f183210badf0c6743ad95.svg";
export { ForwardRef as ReactComponent };